export default /*@ngInject*/ function ($q, RequestManagementAXService, RequestManagementAX7LicenseService, configurationDataService) {

    this.loadAX7 = function ($scope) {
        var axDfrd = $.Deferred();

        loadAX7Permissions($scope).done(function () {
            axDfrd.resolve();
        });

        return $.when(axDfrd).done(function () {
        }).promise();
    };

    this.loadAX7LoadPermisssions = function ($scope) {
        return loadAX7Permissions($scope);
    };
    //Load the AX permissions, after that completes and if there is an existing AX user load their permissions
    function loadAX7Permissions($scope) {
        var permissionsDfrd = $.Deferred(),
            promises = [],
            axRoles = [],
            pendingRoles = $scope.vm.User?.AX7User?.PendingRoleCompanies || [],
            pendingUserGroups = $scope.vm.User?.AX7User?.PendingUserGroups || [];

        $scope.vm.ListOfSelectedAX7Roles = [];
        $scope.vm.ListOfAvailableAX7Roles = [];
        $scope.vm.ListOfSelectedAX7UserGroups = [];
        $scope.vm.ListOfAvailableAX7UserGroups = [];

        if ($scope.vm.User.AX7User != null && $scope.vm.User.AX7User.UserId != null) {

            //If any axRoles are selected in the request set the axRoles valid property to true below
            $scope.vm.numberOfAXRolesValid = false;

            axRoles = $scope.vm.User.AX7User.RoleCompanies || [];

            if (axRoles?.length > 0) {
                $scope.vm.numberOfAXRolesValid = true;
            }
        }

        //Load Available axRoles then process existing security
        promises.push(RequestManagementAXService.getAllAX7Roles().then(function (response) {
            $scope.vm.ListOfAvailableAX7Roles = response.data.filter(applyPendingByKey.bind(null, "Role", pendingRoles));

            // we need to pre-select the system user role
            var systemUserRole = $scope.vm.ListOfAvailableAX7Roles.find(role => role.Id === 'SystemUser');

            if ($scope.vm.wizardMode === 'New' && !$scope.defaultRoleTemplate) {

                $scope.vm.ListOfAvailableAX7Roles.forEach((row, i) => {
                    if (row.Id == systemUserRole.Id) {
                        $scope.vm.ListOfAvailableAX7Roles.splice(i, 1);
                        $scope.vm.ListOfSelectedAX7Roles.push(systemUserRole);
                    }
                });
            } else if ($scope.vm.wizardMode === "New" && $scope.defaultRoleTemplate) {
                let defaultRoles = $scope.defaultRoleTemplate.Roles.filter(role => role.TypeId === "Role" && role.ProductType === "AX7");

                $scope.vm.ListOfSelectedAX7Roles = [...defaultRoles];
                $scope.vm.ListOfAvailableAX7Roles = $scope.vm.ListOfAvailableAX7Roles.filter(availableRole => {
                    let selectedRole = $scope.vm.ListOfSelectedAX7Roles.find(selectedRole => selectedRole.Id === availableRole.Id);

                    if (selectedRole) {
                        selectedRole = Object.merge(selectedRole, availableRole);
                    }

                    return !selectedRole;
                });

                $scope.vm.ListOfSelectedAX7Roles.push(systemUserRole);
            }

            if ($scope.vm.ListOfSelectedAX7Roles.length) {
                $scope.vm.numberOfAXRolesValid = true;
            }

        }, function errorCallback(response) {
            permissionsDfrd.reject();
        }));

        promises.push(RequestManagementAXService.getAllAX7Companies().then(function (response) {
            $scope.vm.ListOfAX7Companies = response.data;

            if ($scope.vm.axCompanyDropdownDataSource) {
                $scope.vm.axCompanyDropdownDataSource.read();
            }
        }, function errorCallback(response) {
            permissionsDfrd.reject();
        }));

        //Load Available axUserGroups then process existing security
        promises.push(RequestManagementAXService.getAllAX7UserGroups().then(function (response) {
            $scope.vm.ListOfAvailableAX7UserGroups = response.data.map(applyPending.bind(null, pendingUserGroups));
        }, function errorCallback(response) {
            permissionsDfrd.reject();
        }));

        $q.all(promises).then(function () {

            //Load AX user roles
            if ($scope.vm.User.AX7User.RoleCompanies != null) {
                $scope.vm.User.AX7User.RoleCompanies.forEach(roleCompany => {

                    var axRole = null;
                    var selectedAXRole = null;
                    var selectedCompany = null;

                    //Get the role information from the available axRoles list
                    axRole = $scope.vm.ListOfAvailableAX7Roles.find(object => object.Id.toUpperCase() === roleCompany.Role.Id.toUpperCase());

                    //Check if the company Id has been set for the current role company
                    if (roleCompany.Company != null) {
                        selectedCompany = $scope.vm.ListOfAX7Companies.find(object => object.CompanyId.toUpperCase() === roleCompany.Company.CompanyId.toUpperCase());
                    }


                    //Check if the role already exists in the selected list
                    selectedAXRole = $scope.vm.ListOfSelectedAX7Roles.find(object => object.Id.toUpperCase() === roleCompany.Role.Id.toUpperCase());
                    //If the role already exists add the current company information to the company list
                    if (selectedAXRole != null && selectedCompany != null) {
                        if (selectedAXRole.Companies == null) {
                            selectedAXRole.Companies = [];
                        }
                        if (selectedAXRole.Companies.none(company => company.CompanyId.toUpperCase() === selectedCompany.CompanyId.toUpperCase())) {
                            selectedAXRole.Companies.push(selectedCompany);
                        }
                    } else {
                        if (axRole != null) {
                            $scope.vm.ListOfSelectedAX7Roles.unshift({
                                Id: axRole.Id,
                                Name: axRole.Name,
                                IsAssignable: axRole.IsAssignable,
                                Description: axRole.Description,
                                Identifier: axRole.Identifier,
                                Companies: selectedCompany == null ? null : [selectedCompany],
                                Pending: pendingRoles.find(pendingRole => pendingRole.Role.Id.toUpperCase() === axRole.Id.toUpperCase() && axRole.Id !== "SystemUser")
                            });

                            $scope.vm.ListOfAvailableAX7Roles.forEach(function (row, j) {
                                if (row.Id.toUpperCase() === axRole.Id.toUpperCase()) {
                                    $scope.vm.ListOfAvailableAX7Roles.splice(j, 1);
                                }
                            });
                        }
                    }

                    axRole = null;
                    selectedCompany = null;

                    $scope.vm.numberOfAXRolesValid = true;
                });
            }
            $scope.vm.ListOfAvailableAX7Roles = $scope.vm.ListOfAvailableAX7Roles.filter(role => role.IsAssignable);

            //Load AX user groups
            if ($scope.vm.User.AX7User.UserGroups != null) {
                $scope.vm.User.AX7User.UserGroups.forEach(userGroup => {

                    var axUserGroup = null;
                    var selectedAXUserGroup = null;

                    //Get the role information from the available axRoles list
                    axUserGroup = $scope.vm.ListOfAvailableAX7UserGroups.find(object => object.Id.toUpperCase() === userGroup.Id.toUpperCase());


                    //Check if the role already exists in the selected list
                    selectedAXUserGroup = $scope.vm.ListOfSelectedAX7UserGroups.find(object => object.Id.toUpperCase() === userGroup.Id.toUpperCase());
                    if (axUserGroup != null) {
                        $scope.vm.ListOfSelectedAX7UserGroups.unshift({
                            Id: axUserGroup.Id, Name: axUserGroup.Name,
                            Pending: pendingUserGroups.find(pendingGroup => pendingGroup.Id.toUpperCase() === axUserGroup.Id.toUpperCase())
                        });

                        $scope.vm.ListOfAvailableAX7UserGroups.forEach(function (row, j) {
                            if (row.Id.toUpperCase() === axUserGroup.Id.toUpperCase()) {
                                $scope.vm.ListOfAvailableAX7UserGroups.splice(j, 1);
                            }
                        });
                    }
                    axUserGroup = null;
                });
            }

            $scope.axUserLoaded = true;
            permissionsDfrd.resolve();
        });

        return $.when(permissionsDfrd).done(function () {
        }).promise();

    }

    this.loadAX2012 = function (scope) {
        var axDfrd = $.Deferred();

        loadAX2012Permissions(scope).done(function () {
            axDfrd.resolve();
        });

        return $.when(axDfrd).done(function () {
        }).promise();
    };

    this.loadAX2012LoadPermisssions = function ($scope) {
        return loadAX2012Permissions($scope);
    };
    //Load the AX permissions, after that completes and if there is an existing AX user load their permissions
    function loadAX2012Permissions($scope) {
        let permissionsDfrd = $.Deferred(),
            promises = [],
            axRoles = [],
            pendingRoles = $scope.vm.User?.AX2012User?.PendingRoleCompanies || [],
            pendingUserGroups = $scope.vm.User?.AX2012User?.PendingUserGroups || [];

        $scope.vm.ListOfSelectedAX2012Roles = [];
        $scope.vm.ListOfAvailableAX2012Roles = [];
        $scope.vm.ListOfSelectedAX2012UserGroups = [];
        $scope.vm.ListOfAvailableAX2012UserGroups = [];

        if ($scope.vm.User.AX2012User != null && $scope.vm.User.AX2012User.UserId != null) {

            //If any axRoles are selected in the request set the axRoles valid property to true below
            $scope.vm.numberOfAXRolesValid = false;

            axRoles = $scope.vm.User.AX2012User.RoleCompanies;

            if (axRoles.length > 0) {
                $scope.vm.numberOfAXRolesValid = true;
            }
        }

        //Load Available axRoles then process existing security
        promises.push(RequestManagementAXService.getAllAX2012Roles().then(function (response) {
            $scope.vm.ListOfAvailableAX2012Roles = response.data.map(applyPendingByKey.bind(null, "Role", pendingRoles));
            let systemUserRole = $scope.vm.ListOfAvailableAX2012Roles.find(role => role.Name === 'SystemUser');

            if ($scope.vm.wizardMode === 'New' && !$scope.defaultRoleTemplate) {
                // we need to pre-select the system user role

                $scope.vm.ListOfAvailableAX2012Roles.forEach((row, i) => {
                    if (row.Id === systemUserRole.Id) {
                        $scope.vm.ListOfAvailableAX2012Roles.splice(i, 1);
                        $scope.vm.ListOfSelectedAX2012Roles.push(systemUserRole);
                    }
                });
            } else if ($scope.vm.wizardMode === "New" && $scope.defaultRoleTemplate) {
                let defaultRoles = $scope.defaultRoleTemplate.Roles.filter(role => role.TypeId === "Role" && role.ProductType === "AX");

                $scope.vm.ListOfSelectedAX2012Roles = [...defaultRoles];
                $scope.vm.ListOfAvailableAX2012Roles = $scope.vm.ListOfAvailableAX2012Roles.filter(availableRole => {
                    let selectedRole = $scope.vm.ListOfSelectedAX2012Roles.find(selectedRole => selectedRole.Id === availableRole.Id);

                    if (selectedRole) {
                        selectedRole = Object.merge(selectedRole, availableRole);
                    }

                    return !selectedRole;
                });
                $scope.vm.ListOfSelectedAX2012Roles.push(systemUserRole);
            }

            if ($scope.vm.ListOfSelectedAX2012Roles.length) {
                $scope.vm.numberOfAXRolesValid = true;
            }

        }, function errorCallback(response) {
            permissionsDfrd.reject();
        }));

        promises.push(RequestManagementAXService.getAllAX2012Partitions().then(function (response) {
            $scope.vm.ListOfAX2012Partitions = response.data;
            $scope.vm.User.AX2012User.Partition = $scope.vm.ListOfAX2012Partitions.find(p => p.Key === 'initial');

        }, function errorCallback(response) {
            permissionsDfrd.reject();
        }));

        //Load Available axUserGroups then process existing security
        promises.push(RequestManagementAXService.getAllAX2012UserGroups().then(function (response) {
            $scope.vm.ListOfAvailableAX2012UserGroups = response.data.map(applyPending.bind(null, pendingUserGroups));
        }, function errorCallback(response) {
            permissionsDfrd.reject();
        }));

        $q.all(promises).then(async function () {

            // load AX Companies
            let axCompanies = await RequestManagementAXService.getAllAX2012Companies($scope.vm.User.AX2012User.Partition.Key);

            $scope.vm.ListOfAX2012Companies = axCompanies.data;

            if ($scope.vm.axCompanyDropdownDataSource) {
                $scope.vm.axCompanyDropdownDataSource.read();
            }
            //Load AX user roles
            if ($scope.vm.User.AX2012User.RoleCompanies != null) {
                $scope.vm.User.AX2012User.RoleCompanies.forEach(function (roleCompany) {

                    var axRole = null;
                    var selectedAXRole = null;
                    var selectedCompany = null;

                    //Get the role information from the available axRoles list
                    axRole = $scope.vm.ListOfAvailableAX2012Roles.find(function (object) {
                        return object.Id.toUpperCase() === roleCompany.Role.Id.toUpperCase();
                    });
                    //Check if the company Id has been set for the current role company
                    if (roleCompany.Company != null) {
                        selectedCompany = $scope.vm.ListOfAX2012Companies.find(object => object.CompanyId.toUpperCase() === roleCompany.Company.CompanyId.toUpperCase());
                    }

                    //Check if the role already exists in the selected list
                    selectedAXRole = $scope.vm.ListOfSelectedAX2012Roles.find(object => object.Id.toUpperCase() === roleCompany.Role.Id.toUpperCase());
                    //If the role already exists add the current company information to the company list
                    if (selectedAXRole != null && selectedCompany != null) {
                        if (selectedAXRole.Companies == null) {
                            selectedAXRole.Companies = [];
                        }
                        if (selectedAXRole.Companies.none(company => company.CompanyId.toUpperCase() === selectedCompany.CompanyId.toUpperCase())) {
                            selectedAXRole.Companies.push(selectedCompany);
                        }
                    }
                    else {
                        if (axRole != null) {
                            $scope.vm.ListOfSelectedAX2012Roles.unshift({
                                Id: axRole.Id,
                                Name: axRole.Name,
                                IsAssignable: axRole.IsAssignable,
                                Description: axRole.Description,
                                Identifier: axRole.Identifier,
                                Companies: selectedCompany == null ? null : [selectedCompany],
                                Pending: pendingRoles.some(pendingRole => pendingRole.Role.Id.toUpperCase() === axRole.Id.toUpperCase() && axRole.Name !== "SystemUser")
                            });


                            $scope.vm.ListOfAvailableAX2012Roles.forEach(function (row, j) {
                                if (row.Id.toUpperCase() === axRole.Id.toUpperCase()) {
                                    $scope.vm.ListOfAvailableAX2012Roles.splice(j, 1);
                                }
                            });
                        }
                    }

                    axRole = null;
                    selectedCompany = null;

                    $scope.vm.numberOfAXRolesValid = true;
                });
            }
            $scope.vm.ListOfAvailableAX2012Roles = $scope.vm.ListOfAvailableAX2012Roles.filter(role => role.IsAssignable);

            //Load AX user groups
            if ($scope.vm.User.AX2012User.UserGroups != null) {
                $scope.vm.User.AX2012User.UserGroups.forEach(userGroup => {
                    var ax2012UserGroup = null;

                    //Get the role information from the available axRoles list
                    ax2012UserGroup = $scope.vm.ListOfAvailableAX2012UserGroups.find(object => object.Id.toUpperCase() === userGroup.Id.toUpperCase());

                    if (ax2012UserGroup != null) {
                        $scope.vm.ListOfSelectedAX2012UserGroups.unshift({
                            Id: ax2012UserGroup.Id,
                            Name: ax2012UserGroup.Name,
                            Pending: pendingUserGroups.some(pendingUserGroup => pendingUserGroup.Id === ax2012UserGroup.Id)
                        });

                        $scope.vm.ListOfAvailableAX2012UserGroups.forEach(function (row, j) {
                            if (row.Id.toUpperCase() === ax2012UserGroup.Id.toUpperCase()) {
                                $scope.vm.ListOfAvailableAX2012UserGroups.splice(j, 1);
                            }
                        });
                    }
                    ax2012UserGroup = null;
                });
            }

            $scope.axUserLoaded = true;
            permissionsDfrd.resolve();
        });

        return $.when(permissionsDfrd).done(function () {
        }).promise();
    }

    /**
     * Load AX7 License Analysis
     * Analyzes license impact for selected roles and loads configuration for linked AAD license request
     * @param {Object} $scope - The scope object containing the view model
     * @returns {Promise} Promise that resolves when license analysis is complete
     */
    this.loadAX7LicenseAnalysis = async function ($scope) {
        $scope.vm.isLoadingLicenseAnalysis = true;
        $scope.vm.licenseAnalysisLoaded = false;
        $scope.vm.licenseAnalysisError = null;

        try {
            await loadAX7LicenseConfiguration($scope);
            await performAX7LicenseImpactAnalysis($scope);
            $scope.vm.isLoadingLicenseAnalysis = false;
            $scope.vm.licenseAnalysisLoaded = true;
        } catch (error) {
            $scope.vm.licenseAnalysisError = error.message || 'An error occurred while analyzing license impact.';
            $scope.vm.isLoadingLicenseAnalysis = false;
            $scope.vm.licenseAnalysisLoaded = true;
            throw error;
        }
    };

    /**
     * Load AX7 license-related configuration
     * @param {Object} $scope - The scope object
     * @returns {Promise} Promise that resolves when configuration is loaded
     */
    async function loadAX7LicenseConfiguration($scope) {
        try {
            var response = await configurationDataService.getProductConfigurationValueByName('ax7', 'IM_Ax7_AutoCreateAadLicenseRequest');
            $scope.vm.EnableAutoCreateAadLicenseRequest = response?.data?.Value === 'true' || response?.data?.Value === '1';
        } catch (error) {
            console.warn('Failed to load AAD license request configuration, defaulting to false:', error);
            $scope.vm.EnableAutoCreateAadLicenseRequest = false;
        }
    }

    /**
     * Perform license impact analysis
     * @param {Object} $scope - The scope object
     * @returns {Promise} Promise that resolves when analysis is complete
     */
    async function performAX7LicenseImpactAnalysis($scope) {
        var ax7Request = buildAX7RequestForAnalysis($scope);

        if (!ax7Request.RoleCompanies || ax7Request.RoleCompanies.length === 0) {
            setNoLicenseChange($scope);
            return;
        }

        var response = await RequestManagementAX7LicenseService.analyzeLicenseImpact(ax7Request);
        processAX7LicenseAnalysisResponse($scope, response.data);
    }

    /**
     * Build AX7 request object for license analysis
     * @param {Object} $scope - The scope object
     * @returns {Object} AX7 request object with RoleCompanies structure
     */
    function buildAX7RequestForAnalysis($scope) {
        var roleCompanies = [];
        var productId = $scope.vm.User?.AX7User?.ProductId || 'AX7';
        var userId = $scope.vm.User?.AX7User?.UserId || null;
        var userMasterId = $scope.vm.User?.UserMaster?.Id || null;

        // Helper function to create a RoleCompany entry
        // Matches the structure used in RequestManagementBuildRequestService
        function createRoleCompanyEntry(role, company, action) {
            // Convert action string to enum value
            // RequestAccessEventType: Grant = 1, Revoke = 2, Exclude = 3
            var actionEnum = action === 'Grant' ? 1 : (action === 'Revoke' ? 2 : null);

            var entry = {
                UserId: userId,
                Action: actionEnum, // Use enum value (1 for Grant, 2 for Revoke)
                StartDate: company ? (company.StartDate || null) : (role.StartDate || null),
                EndDate: company ? (company.EndDate || null) : (role.EndDate || null),
                Role: {
                    Id: role.Id,
                    Name: role.Name,
                    Description: role.Description || null
                },
                Company: company ? {
                    CompanyId: company.CompanyId,
                    CompanyName: company.CompanyName,
                    CompanyType: company.CompanyType || 0 // LegalEntityType.LegalEntity = 0
                } : null
            };
            return entry;
        }

        // Build role grants from selected roles
        if ($scope.vm.ListOfSelectedAX7Roles && $scope.vm.ListOfSelectedAX7Roles.length > 0) {
            $scope.vm.ListOfSelectedAX7Roles.forEach(function(role) {

                if (role.Companies && role.Companies.length > 0) {
                    // Create an entry for each company
                    role.Companies.forEach(function(company) {
                        roleCompanies.push(createRoleCompanyEntry(role, company, 'Grant'));
                    });
                } else {
                    // Create a single entry with no company
                    roleCompanies.push(createRoleCompanyEntry(role, null, 'Grant'));
                }
            });
        }

        // Build request object, only including properties with values
        var request = {
            ProductId: productId,
            RoleCompanies: roleCompanies
        };

        // Only include UserId if it has a value
        if (userId) {
            request.UserId = userId;
        }

        // Only include UserMasterId if it has a value
        if (userMasterId) {
            request.UserMasterId = userMasterId;
        }

        return request;
    }

    /**
     * Process the license analysis response
     * @param {Object} $scope - The scope object
     * @param {Object} data - The response data from backend
     */
    function processAX7LicenseAnalysisResponse($scope, data) {
        // Store the analysis result with backend property names
        // Combine top-level driving roles with attach license driving roles
        // Enrich each role with its corresponding AadSkuId
        var allDrivingRoles = (data.DrivingRoles || []).map(function (role) {
            role.AadSkuId = data.RequiredAadSkuId || '';
            return role;
        });
        if (data.AttachLicenses && data.AttachLicenses.length > 0) {
            data.AttachLicenses.forEach(function (attachLicense) {
                if (attachLicense.DrivingRoles && attachLicense.DrivingRoles.length > 0) {
                    var enrichedRoles = attachLicense.DrivingRoles.map(function (role) {
                        role.AadSkuId = attachLicense.AadSkuId || '';
                        return role;
                    });
                    allDrivingRoles = allDrivingRoles.concat(enrichedRoles);
                }
            });
        }

        $scope.vm.licenseAnalysisResult = {
            UserId: data.UserId,
            UserName: data.UserName,
            CurrentLicenseSku: data.CurrentLicenseSku || 'None',
            CurrentLicenseGroupName: data.CurrentLicenseGroupName,
            CurrentLicensePriority: data.CurrentLicensePriority,
            RequiredLicenseSku: data.RequiredLicenseSku || 'None',
            RequiredLicenseGroupName: data.RequiredLicenseGroupName,
            RequiredLicensePriority: data.RequiredLicensePriority,
            ChangeType: data.ChangeType, // Enum: 0=NoChange, 1=Upgrade, 2=Downgrade
            DrivingRoles: data.DrivingRoles || [],
            AllDrivingRoles: allDrivingRoles,
            AttachLicenses: data.AttachLicenses || [],
            RevokeLicenses: data.RevokeLicenses || [],
            CurrentAadSkuId: data.CurrentAadSkuId,
            RequiredAadSkuId: data.RequiredAadSkuId,
            AadLicenseChangeRequired: data.AadLicenseChangeRequired,
            PrepaidUnitsEnabled: 0
        };

        // Fetch prepaid units for the required license SKU (only when auto-create is enabled)
        if (data.RequiredAadSkuId && $scope.vm.EnableAutoCreateAadLicenseRequest) {
            RequestManagementAX7LicenseService.getPrepaidUnits(data.RequiredAadSkuId)
                .then(function (response) {
                    $scope.vm.licenseAnalysisResult.PrepaidUnitsEnabled = response.data.PrepaidUnitsEnabled || 0;
                });
        }

        // Determine license change type from enum value
        determineLicenseChangeType($scope, data.ChangeType);

        // Determine if the toggle should be shown
        updateToggleVisibility($scope);
    }

    /**
     * Determine the license change type from API response
     * @param {Object} $scope - The scope object
     * @param {String} changeType - The license change type string ("NoChange", "Upgrade", "Downgrade")
     */
    function determineLicenseChangeType($scope, changeType) {
        // API returns string values, not numeric enums
        switch (changeType) {
            case 'Upgrade':
                $scope.vm.licenseChangeType = 'Upgrade';
                $scope.vm.showRoleDetails = true;
                break;
            case 'Downgrade':
                $scope.vm.licenseChangeType = 'Downgrade';
                $scope.vm.showRoleDetails = true;
                break;
            case 'NoChange':
            default:
                $scope.vm.licenseChangeType = 'NoChange';
                $scope.vm.showRoleDetails = false;
                break;
        }
    }

    /**
     * Set no license change state
     * @param {Object} $scope - The scope object
     */
    function setNoLicenseChange($scope) {
        $scope.vm.licenseAnalysisResult = {
            CurrentLicenseSku: 'None',
            CurrentLicenseGroupName: null,
            RequiredLicenseSku: 'None',
            RequiredLicenseGroupName: null,
            ChangeType: 0, // NoChange
            DrivingRoles: [],
            AadLicenseChangeRequired: false
        };
        $scope.vm.licenseChangeType = 'NoChange';
        $scope.vm.showRoleDetails = false;
        $scope.vm.isLoadingLicenseAnalysis = false;
        $scope.vm.licenseAnalysisLoaded = true;
        updateToggleVisibility($scope);
    }

    /**
     * Update the visibility of the Create Linked Request toggle
     * @param {Object} $scope - The scope object
     */
    function updateToggleVisibility($scope) {
        // Show toggle only if:
        // 1. Configuration is enabled
        // 2. License change is Upgrade or Downgrade
        $scope.vm.showCreateLinkedRequestToggle =
            $scope.vm.EnableAutoCreateAadLicenseRequest &&
            ($scope.vm.licenseChangeType === 'Upgrade' || $scope.vm.licenseChangeType === 'Downgrade');

        // Reset the toggle value if not shown
        if (!$scope.vm.showCreateLinkedRequestToggle) {
            $scope.vm.CreateLinkedAadLicenseRequest = false;
        }
    }
}

function applyPendingByKey(key, pendingItems, item) {
    if (pendingItems.length) {
        item.Pending = pendingItems.some(pendingItem => pendingItem[key].Id.toUpperCase() === item.Id.toUpperCase());
    } else {
        item.Pending = false;
    }

    return item;
}

function applyPending(pendingItems, item) {
    if (pendingItems.length) {
        item.Pending = pendingItems.some(pendingItem => pendingItem.Id.toUpperCase() === item.Id.toUpperCase());
    } else {
        item.Pending = false;
    }

    return item;
}